import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';

import { FireIcon } from '../icons';

export function CouponAppliedTag({ value }: { value: number }) {
  if (value <= 0 || value > 100) return null;
  return (
    <Tag colorScheme='orange' size='sm' whiteSpace='nowrap'>
      <TagLeftIcon as={FireIcon} height='16px' marginEnd={1} width='16px' />
      <TagLabel>{value}% off</TagLabel>
    </Tag>
  );
}
